import { get } from 'lodash';

export default function required(tabData, options) {
  const value = get(tabData, options.path);
  return value !== '' && value != null;
}
